import React from 'react';
import { Lock, Pencil } from 'lucide-react';
import { parseISO } from 'date-fns';
import { pad, hourOf, isBlock, bookingPhase } from './tennisCalendarUtils';

const phaseBadge = {
  past: 'bg-slate-200 text-slate-600',
  active: 'bg-blue-500/20 text-blue-700',
  upcoming: 'bg-green-500/20 text-green-700',
  cancelled: 'bg-red-500/20 text-red-600',
};
const phaseLabel = { past: 'Tidligere', active: 'Pågår', upcoming: 'Kommende', cancelled: 'Kansellert' };

export const BookingList = ({ bookings, onEdit }) => (
  <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden" data-testid="tennis-cal-list">
    {bookings.length === 0 ? (
      <div className="p-8 text-center text-slate-500">Ingen bookinger i valgt periode/filter</div>
    ) : (
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-left text-slate-500">
              <th className="py-3 px-4 font-medium">Dato</th>
              <th className="py-3 px-4 font-medium">Tid</th>
              <th className="py-3 px-4 font-medium">Bane</th>
              <th className="py-3 px-4 font-medium">Medlem / årsak</th>
              <th className="py-3 px-4 font-medium hidden md:table-cell">Kontakt</th>
              <th className="py-3 px-4 font-medium">Status</th>
              <th className="py-3 px-4" />
            </tr>
          </thead>
          <tbody>
            {bookings.map((b) => {
              const phase = b.status === 'cancelled' ? 'cancelled' : bookingPhase(b);
              return (
                <tr key={b.id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`cal-list-row-${b.id}`}>
                  <td className="py-3 px-4 font-medium text-slate-900 whitespace-nowrap">{parseISO(b.date).toLocaleDateString('no-NO')}</td>
                  <td className="py-3 px-4 whitespace-nowrap font-mono text-slate-700">{b.time_slot}–{pad(hourOf(b.time_slot) + (b.duration_hours || 1))}</td>
                  <td className="py-3 px-4 text-slate-600">Bane {b.court_number}</td>
                  <td className="py-3 px-4 text-slate-900">
                    <span className="flex items-center gap-1.5">{isBlock(b) && <Lock className="w-3.5 h-3.5 text-slate-500" />}{b.member_name}</span>
                    {b.note && <span className="block text-xs text-slate-400">{b.note}</span>}
                  </td>
                  <td className="py-3 px-4 text-slate-500 hidden md:table-cell">
                    {b.member_phone && <span className="block">{b.member_phone}</span>}
                    {b.member_email && <span className="block text-xs">{b.member_email}</span>}
                  </td>
                  <td className="py-3 px-4"><span className={`px-2 py-1 text-xs rounded ${phaseBadge[phase]}`}>{phaseLabel[phase]}</span></td>
                  <td className="py-3 px-4 text-right">
                    {b.status !== 'cancelled' && (
                      <button type="button" onClick={() => onEdit(b)} data-testid={`cal-list-edit-${b.id}`} className="inline-flex items-center gap-1 text-xs font-semibold text-slate-700 hover:text-black bg-slate-100 hover:bg-[#CCFF00] px-2.5 py-1.5 rounded-md transition-colors">
                        <Pencil className="w-3 h-3" /> Endre
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )}
  </div>
);
